import moment from 'moment';
import { React, useEffect, useState } from 'react';
import styled from 'styled-components';

import { formatPhoneNumber } from '../../../Utils/phoneUtils';
import { useLanguage } from '../../../Context/LanguageContext';
import { useTheme } from '../../../Context/ThemeContext';

const ValidMemberInfo = (props) => {
  const { data, onClick } = props;
  const { t, languageMode } = useLanguage();
  const { isDark } = useTheme();

  const [isExistNotReceived, setIsExistNotReceived] = useState(false);

  useEffect(() => {
    if (data.notReceivedPrice === 0 || data.notReceivedPrice === undefined) setIsExistNotReceived(false);
    else setIsExistNotReceived(true);
  }, [data])

  // 회원권 이름과 +n 접미사 분리 //
  function parseMembershipName() {
    const name = data.viewMembershipName || '';
    const match = name.match(/^(.*?)(\s\+\d+.*)$/);
    if (match) return { base: match[1], suffix: match[2] };
    return { base: name, suffix: '' };
  }

  // 전화번호 뷰 정리 //
  function selectPhoneView() {
    if (!data.phone || data.phone === '') return t('validMember.noPhone');
    return formatPhoneNumber(data.phone, data.countryCode, languageMode) || t('validMember.noPhone');
  }

  return (
    <TopLevelWrapper onClick={onClick} $isDark={isDark}>
      <Table>
        <Body>
          <Tr style={{ width: '110px' }}>
            <Td>
              <TextWrapper style={{ maxWidth: '110px' }}>
                <Text isExistNotReceived={isExistNotReceived}>{data.name}</Text>
              </TextWrapper>
            </Td>
          </Tr>
          <Tr style={{ width: '60px' }}>
            <Td>
              <TextWrapper style={{ maxWidth: '60px' }}>
                <Text isExistNotReceived={isExistNotReceived}>{data.gender === 'male' ? t('validMember.male') : t('validMember.female')}</Text>
              </TextWrapper>
            </Td>
          </Tr>
          <Tr style={{ width: '80px' }}>
            <Td>
              <TextWrapper style={{ maxWidth: '80px' }}>
                <Text isExistNotReceived={isExistNotReceived}>{moment(data.birthDay, 'YYYYMMDD').format(t('validMember.birthFormat'))}</Text>
              </TextWrapper>
            </Td>
          </Tr>
          <Tr style={{ width: '130px' }}>
            <Td>
              <TextWrapper style={{ maxWidth: '130px' }}>
                <Text isExistNotReceived={isExistNotReceived}>{selectPhoneView()}</Text>
              </TextWrapper>
            </Td>
          </Tr>
          <Tr style={{ width: '220px' }}>
            <Td>
              <MembershipNameWrapper>
                <MembershipNameText isExistNotReceived={isExistNotReceived}>{parseMembershipName().base}</MembershipNameText>
                {
                  parseMembershipName().suffix &&
                  <Text isExistNotReceived={isExistNotReceived} style={{whiteSpace: 'nowrap'}}>{parseMembershipName().suffix}</Text>
                }
              </MembershipNameWrapper>
            </Td>
          </Tr>
          <Tr style={{ width: '75px' }}>
            <Td>
              <TextWrapper style={{ maxWidth: '75px' }}>
                <Text isExistNotReceived={isExistNotReceived}>{moment(data.viewStartDate).format(t('validMember.dateFormat'))}</Text>
              </TextWrapper>
            </Td>
          </Tr>
          <Tr style={{ width: '115px' }}>
            <Td>
              <TextWrapper style={{ maxWidth: '115px' }}>
                <Text isExistNotReceived={isExistNotReceived}>{moment(data.viewEndDate).format(t('validMember.dateFormat'))}</Text>
              </TextWrapper>
            </Td>
          </Tr>
          <Tr style={{ width: '75px' }}>
            <Td>
              <CountDdayWrapper>
                <Text isExistNotReceived={isExistNotReceived}>{data.viewCount}</Text>
                {
                  moment(data.viewEndDate).diff(moment(), 'day') <= 5 &&
                  <Dday>{moment(moment(data.viewEndDate).format('YYYY-MM-DD')).diff(moment(moment().format('YYYY-MM-DD')), 'day') === 0 ? 'D-day' : 'D-' + moment(moment(data.viewEndDate).format('YYYY-MM-DD')).diff(moment(moment().format('YYYY-MM-DD')), 'day')}</Dday>
                }
              </CountDdayWrapper>
            </Td>
          </Tr>
        </Body>
      </Table>
    </TopLevelWrapper>
  )
};

export default ValidMemberInfo;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  align-items: center;

  width: 970px;
  height: 50px;

  margin-top: 10px;

  border: 1px solid ${props => props.theme.subBackground};
  border-radius: 30px;
  background: ${props => props.theme.subBackground};

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
    border: 1px solid ${props => props.theme.primary};
  }
`;

const Table = styled.table`
  display: flex;
  flex-direction: row;
`;

const Body = styled.tbody`
  display: flex;
  flex-direction: row;
  
  margin-left: 20px;

  gap: 10px;
`;

const Tr = styled.tr`
  display: flex;
  flex-direction: row;
`;

const Td = styled.td`
  display: flex;
  flex-direction: row;

  width: 100%;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  max-height: 20px;
`;

const Text = styled.span`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.isExistNotReceived ? props.theme.primary : props.theme.text};
  
  margin: 0 0 0 0;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const MembershipNameWrapper = styled.div`
  display: flex;
  flex-direction: row;

  align-items: center;

  width: 210px;
  min-width: 0;

  gap: 4px;

  overflow: hidden;
`;

const MembershipNameText = styled.span`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.isExistNotReceived ? props.theme.primary : props.theme.text};

  margin: 0;

  flex-shrink: 1;
  min-width: 0;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const CountDdayWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
`;

const Dday = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  box-sizing: border-box;
  width: 46px;
  height: 18px;

  border-radius: 30px;
  background-color: ${props => props.theme.primary};

  font-family: NotoSansKR-Medium;
  font-size: 11px;

  color: ${props => props.theme.background};

  margin: 0 0 0 0;
`;
